import { useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const TOUR_KEY = "hindcast_validation_tour_v1";

export function useTour() {
  useEffect(() => {
    if (localStorage.getItem(TOUR_KEY)) return;

    // Delay slightly to ensure the sidebar has fully rendered
    const timeout = setTimeout(() => {
      const tour = driver({
        showProgress: true,
        progressText: "{{current}} of {{total}}",
        overlayOpacity: 0.3,
        showButtons: ["next", "previous", "close"],
        nextBtnText: "Next →",
        prevBtnText: "← Back",
        doneBtnText: "Done",
        onDestroyStarted: () => {
          localStorage.setItem(TOUR_KEY, "1");
          tour.destroy();
        },
        steps: [
          {
            element: "#tour-datasource",
            popover: {
              title: "Select a datasource",
              description:
                "Choose the hindcast model you want to validate. " +
                "Available datasets cover different ocean regions.",
              side: "right",
              align: "start",
            },
          },
          {
            element: "#tour-variable",
            popover: {
              title: "Choose a variable",
              description:
                "Switch between waves (significant wave height, Hs) and wind speed. " +
                "This updates both the map display and the validation.",
              side: "right",
              align: "start",
            },
          },
          {
            element: "#tour-location",
            popover: {
              title: "Set a location",
              description:
                "Enter coordinates manually here, or click directly on the map " +
                "to pick a point inside a hindcast domain.",
              side: "right",
              align: "start",
            },
          },
          {
            element: "#tour-radius",
            popover: {
              title: "Set the search radius",
              description:
                "All satellite altimeter passes within this radius of your " +
                "selected point will be included in the validation.",
              side: "right",
              align: "start",
            },
          },
          {
            element: "#tour-validate",
            popover: {
              title: "Run the validation",
              description:
                "Click to fetch 30+ years of collocated satellite and hindcast " +
                "data and view the statistical results.",
              side: "right",
              align: "start",
            },
          },
        ],
      });

      tour.drive();
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
}
